import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '../../utils/cn';

export function TabsList({
    className,
    ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                'p-0.75 inline-flex h-9 w-fit items-center justify-center rounded-lg bg-accent text-accent-foreground',
                className,
            )}
            {...props}
        />
    );
}
